import React from 'react';
import isArray from 'lodash/isArray';
import type { Article, BreadcrumbList, FAQPage, ItemList, WebSite, WithContext } from 'schema-dts';

export type Schemas =
  | WithContext<FAQPage>
  | WithContext<Article>
  | WithContext<BreadcrumbList>
  | ItemList[]
  | WebSite;

export type SchemasProps<T = Schemas> = {
  schemas: T | T[];
};

const Schemas = <T,>({ schemas }: SchemasProps<T>): JSX.Element =>
  isArray(schemas) ? (
    <>
      {schemas.map((schema, index) => (
        <script
          type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          key={`seo-schema-${index}`}
        />
      ))}
    </>
  ) : (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemas) }}
    />
  );

export default Schemas;
